//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NoticesItem from '@/components/popup/NoticesItem'
import CustomPopup from '@/components/popup/CustomPopup.vue'

export default {
  name: 'PopupNotices',
  props: ['value', 'notifications'],
  components: {
    NoticesItem,
    CustomPopup
  },
  data() {
    return {
      showAllNotifications: false,
    }
  },
  computed: {
    filteredNotifications() {
      const notifications = this.$store.getters['notify/getNotifications']
      if (this.showAllNotifications) {
        return notifications
      } else {
        return notifications.filter(notification => notification.status === '0')
      }
    },
  }
}
